module.exports = __webpack_public_path__ + "static/media/rs.b810a300.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/rs.svg
// module id = 1466
// module chunks = 0